import { render, staticRenderFns } from "./PriceIndexSearch.vue?vue&type=template&id=f747b8ce"
import script from "./PriceIndexSearch.vue?vue&type=script&lang=js"
export * from "./PriceIndexSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports